<template>
  <a-dialog v-model="show" max-width="650px" persistent scrollable>
    <v-card>
      <v-toolbar dense color="#CFDDE6" height="48px" dark>
        <v-icon class="darkCharcoal--text" left>mdi-history</v-icon>
        <span> {{ $t("people.AddHistory") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close" />
      </v-toolbar>
      <v-card-text>
        <v-container style="padding: 0 !important">
          <v-form ref="refAddHistoryForm" id="AddHistoryFormId">
            <v-row>
              <v-col cols="12" sm="12" class="mt-2">
                <v-menu
                  ref="menu"
                  v-model="date_dialog_box"
                  :close-on-content-click="false"
                  :close-on-click="true"
                  :return-value.sync="historyData.yearMonth"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <a-text-field
                        class="textField"
                        filled
                        dense
                        v-model="historyData.yearMonth"
                        label="YYYY-MM"
                        prepend-inner-icon="mdi-calendar"
                        @click:prepend-inner="date_dialog_box = true"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                        :requiredMessage="$t('people.reqDate')"
                        :regExp=/[a-zA-Z0-9]/
                      ></a-text-field>
                    </span>
                  </template>
                  <v-date-picker
                    v-model="historyData.yearMonth"
                    type="month"
                    no-title
                    scrollable
                    :max="pickerMax"
                    :locale="selectedLang"
                  >
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">    
                        <a-btn
                          v-bind="attrs" v-on="on"
                          elevation="1"
                          text
                          class="primaryDark mr-2"
                          @click="$refs.menu.save(historyData.yearMonth)"
                        >
                        {{ $t("btnOk") }}
                        </a-btn>
                      </template>
                      <span>{{ $t("btnOk") }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <a-btn v-bind="attrs" v-on="on" elevation="1" text class="secondary" @click="date_dialog_box = false">
                          {{ $t("btnLabelCancel") }}
                        </a-btn>
                      </template>
                      <span>{{ $t("btnLabelCancel") }}</span>
                    </v-tooltip>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <repeat-form-input
              v-model="historyData.description"
              :yearMonth="historyData.yearMonth"
              :allHistoryData="allHistoryData"
              :isNewHistory="isNewHistory"
              @inputValue="scrollForm"
            ></repeat-form-input>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">    
            <a-btn v-bind="attrs" v-on="on" elevation="1" class="primaryDark mr-2" text @click="saveHistory">
              {{ $t("btnSave") }}
            </a-btn>
          </template>
          <span>{{ $t("btnSave") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn v-bind="attrs" v-on="on" elevation="1" class="secondary" text @click="close"
              >{{ $t("btnCancel") }}
            </a-btn>
          </template>
          <span>{{ $t("btnCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import RepeatFormInput from "./RepeatFormInput.vue";
export default {
  name: "AddHistory",
  components: { RepeatFormInput },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    history: {
      type: Object,
      default: () => {},
    },
    allHistoryData: {
      type: Array,
      default: () => [],
    },
    isNewHistory: {
      type: Boolean,
      default: false
    }
  },  
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    historyData: {
      get() {
        return this.history;
      },
      set(value) {
        this.$emit("update:history", value);
      },
    },
    descriptions: {
      get() {
        return this.history.description;
      },
      set(values) {
        this.history.description = values;
      },
    },
    selectedLang() {
      return this.$i18n.locale;
    }
  },
  data() {
    return {
      test: "",
      valid: true,
      date_dialog_box: false,
      descriptionInput: ["hello"],
      pickerMax: new Date().toISOString().substr(0, 10),
    };
  },
  methods: {
    close,
    saveHistory,
    scrollForm(value) {
      if(value && value.length > 0) {
        setTimeout(() => {
          const element = document.getElementById("AddHistoryFormId");
          element.scrollIntoView({ behavior: "instant", block: "end"});
        }, 100)
  
      }
    }
  },
};

function saveHistory() {
  if (this.$refs.refAddHistoryForm.validate()) {
    this.$emit("save");
  }
}

function close() {
  // this.$refs.refAddHistoryForm.resetValidation();
  // this.$refs.refAddHistoryForm.reset();
  this.$emit("input", false);
}
</script>

<style scoped>
.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    box-shadow: none !important;
}
.v-toolbar /deep/ .v-toolbar__content {
 color: var(--v-darkCharcoal-base); 
 font-family: 'Noto Sans JP'; 
 font-size: 14px; 
 font-weight: 700; 
 line-height: 21px;
}
.textField {
  font-family: 'Noto Sans JP' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;  
  align-items: center !important;
  border-radius: 0 !important;
}
.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.textField /deep/ .v-input__control {
  border-radius: 0 !important;
}
.textField > .v-input__control > .v-input__slot > .v-text-field__slot {
  color: var(--v-neutralGray-base) !important;
}
.textField /deep/ .v-input__prepend-outer {
  align-self: flex-start !important;
}
</style>